import React, { createContext, PropsWithChildren, SetStateAction, useState } from "react";

export type IModuleRatingDetailsContext = {
	oneKeyId: string;
	setOneKeyId: React.Dispatch<SetStateAction<string>>;
};

export const ModuleRatingDetailsContext = createContext<IModuleRatingDetailsContext>({
	setOneKeyId: () => {},
	oneKeyId: "",
});

export const ModuleRatingDetailsContextProvider = ({ children }: PropsWithChildren<any>) => {
	const [oneKeyId, setOneKeyId] = useState("");
	return (
		<ModuleRatingDetailsContext.Provider
			value={{
				oneKeyId,
				setOneKeyId,
			}}
		>
			{children}
		</ModuleRatingDetailsContext.Provider>
	);
};
